import { useContext } from 'react'
import { ChartPopoverContext } from './ChartPopoverContext'

export const useChartPopover = () => {
  const value = useContext(ChartPopoverContext)
  if (!value) throw new Error('useChartPopover must be used inside ChartPopoverProvider')
  return value
}
